import { Navigate, useLocation } from "react-router-dom";
import { getProfile, isFullyAuthenticatedForApp, isSSOUser } from "@/utils/helper";
import { useProfileStore } from "@/store/profile";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const profileAuthInfo = useProfileStore((s) => s.profileAuthInfo);
  const currentPatient = useProfileStore((s) => s.currentPatient);

  const profile = getProfile();
  if (profile && isSSOUser(profile)) {
    localStorage.removeItem("portal-profile");
    useProfileStore.getState().logout();
    return <Navigate to="/account/login" state={{ from: location }} replace />;
  }

  if (!isFullyAuthenticatedForApp(profileAuthInfo, currentPatient)) {
    return <Navigate to="/account/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
